import './archive-case-studies.scss';

document.addEventListener('DOMContentLoaded', function () {
	const case_study_block = document.querySelector('.wp-block-unity-blocks-archive-case-studies');
	const case_study_sector = case_study_block.querySelector("#case-study-sector");
	const case_study_department = case_study_block.querySelector("#case-study-department");
	const case_study_container = case_study_block.querySelector(".archive_case_studies_container") || document.body;
	const filters = case_study_block.querySelector('.filters_container');

	if (case_study_sector) {
		case_study_sector.addEventListener('change', () => postsFilter(1));
	}

	if (case_study_department) {
		case_study_department.addEventListener('change', () => postsFilter(1));
	}

	case_study_container.addEventListener('click', function (e) {
		const pageLink = e.target.closest('.case-studies-pagination a');
		if (!pageLink) return;

		e.preventDefault();

		filters.scrollIntoView();

		const url = new URL(pageLink.href);
		const pageNum = url.pathname.match(/\/page\/(\d+)/)?.[1] || url.searchParams.get('paged') || 1;

		postsFilter(parseInt(pageNum, 10));
	});
});

async function postsFilter(page_num) {
	const case_study_container = document.querySelector(".archive_case_studies_container") || document.body;
	const case_study_sector = document.getElementById("case-study-sector");
	const case_study_department = document.getElementById("case-study-department");

	if (!case_study_container) return;

	case_study_container.classList.add('loading');

	let sector = case_study_sector ? case_study_sector.value : null;
	let department = case_study_department ? case_study_department.value : null;

	const formData = new FormData();
	formData.append('action', 'filter_case_studies');
	if (sector) formData.append('case-study-sector', sector);
	if (department) formData.append('case-study-department', department);

	const currentPage = (typeof page_num === 'number') ? page_num : 1;
	formData.append('paged', currentPage);

	try {
		const response = await fetch('/wp-admin/admin-ajax.php', {
			method: 'POST',
			body: formData
		});

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		const data = await response.text();

		case_study_container.classList.remove('loading');
		case_study_container.innerHTML = data;
	} catch (error) {
		console.error('Error fetching filtered posts:', error);
		case_study_container.classList.remove('loading');
	}
}
